import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import anime from 'animejs';

class PageTransition extends Component {
    onEnter = node => {
        let tl = anime.timeline();
        tl
            // scroll to the top
            .add({
                targets: 'html, body',
                scrollTop: 0,
                easing: 'easeOutExpo',
                duration: 500,
                delay: 500,
                complete: function(anim) {
                    node.style.display = 'flex';
                }
            })
            // fade in
            .add({
                targets: node,
                opacity: [0, 1],
                translateY: [-10, 0],
                easing: 'easeOutCubic',
                duration: 750
            });
    };

    onExit = node => {
        const animSpeed = this.props.timeout.exit - 150;
        let tl = anime.timeline();

        tl.add({
            // Fade out and move down
            targets: node,
            opacity: [1, 0],
            translateY: [0, 10],
            easing: 'easeOutCubic',
            duration: animSpeed
        });
    };

    render() {
        return (
            <Transition
                {...this.props}
                timeout={this.props.timeout}
                onEnter={this.onEnter}
                onEntered={this.onEntered}
                onExit={this.onExit}
                mountOnEnter={true}
                unmountOnExit={true}
            />
        );
    }
}

PageTransition.defaultProps = {
    timeout: {
        enter: 1000,
        exit: 650
    }
};

export default PageTransition;



// WEBPACK FOOTER //
// ./src/components/templates/app/transitions.js